import { useState, useEffect } from 'react';

export const useAdmin = () => {
  const [dashboardStats, setDashboardStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Mock data - replace with API call
    setTimeout(() => {
      setDashboardStats({
        totalOrders: 142,
        pendingBookings: 23,
        lowStockItems: 8,
        totalProducts: 347,
      });
      setLoading(false);
    }, 500);
  }, []);

  return { dashboardStats, loading };
};

